<ng-container *ngIf="data.Title.value !== ''">
  <div mat-dialog-title>
    <span class="dialog-title-label" *scText="data.Title"></span>
    <button
      *ngIf="data.HasCloseButtonInHeader.value"
      (click)="dialogRef.close()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
</ng-container>
<div mat-dialog-content>
  <p *scRichText="data.BodyText"></p>
  <ng-container *ngIf="data.items">
    <div>
      <mat-radio-group class="ab-radio-group" [(ngModel)]="selection">
        <mat-radio-button
          class="ab-radio default-radio"
          [value]="option.name"
          *ngFor="let option of data.items; let i = index"
        >
          <span *scText="option.fields.label"></span>
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </ng-container>
</div>
<div mat-dialog-actions>
  <ng-container *ngIf="data.SubmitButtonLabel.value !== ''">
    <button
      class="btn btn-primary btn-mid btn-block btn-md-block-none"
      *scText="data.SubmitButtonLabel"
      (click)="confirm()"
    ></button>
  </ng-container>
  <ng-container *ngIf="data.CancelButtonLabel.value !== ''">
    <button
      class="btn btn-link btn-with-icon btn-block btn-md-block-none"
      (click)="dialogRef.close()"
    >
      <span *scText="data.CancelButtonLabel"></span>
    </button>
  </ng-container>
</div>
